import { useLocation } from "react-router-dom";

import { PROJECTS_BASE_ROUTE } from "globals/constants";
import { TASK_CATEGORIES } from "globals/constants/task";
import { spUrl } from "utils";

export function buildBreadcrumbs ({ record, recordUrl, recordBreadcrumbs, task, newTaskText }) {
	let breadcrumbs = [
		{
			text: "My Active Projects",
			link: spUrl(PROJECTS_BASE_ROUTE),
		},
	];
	if (!recordBreadcrumbs.some(b => b.link.includes(PROJECTS_BASE_ROUTE))) {
		breadcrumbs = breadcrumbs.concat({
			text: record.projectTitle,
			link: spUrl(`${PROJECTS_BASE_ROUTE}/${record.projectId}`),
		});
	}
	breadcrumbs = breadcrumbs.concat(recordBreadcrumbs);

	if (task.id) {
		if (task.milestoneId) {
			breadcrumbs.push({
				text: task.milestoneCounter ?? "",
				link: `${recordUrl}/milestone/${task.milestoneId}`,
			});
		}
		breadcrumbs.push({
			text: task.taskCounterId ?? "",
		});
	} else {
		breadcrumbs.push({
			text: newTaskText,
		});
	}

	return breadcrumbs;
}

export function useShouldRedirectToCorrectTaskDetailsPage (task) {
	const location = useLocation();

	if (task?.category && task.category === TASK_CATEGORIES.CAYUSE_SP_MILESTONE && location.pathname.includes("/task/")) {
		return {
			redirectPath: location.pathname.replace("/task/", "/milestone/"),
		};
	} else if (task?.category && task.category !== TASK_CATEGORIES.CAYUSE_SP_MILESTONE && location.pathname.includes("/milestone/")) {
		return {
			redirectPath: location.pathname.replace("/milestone/", "/task/"),
		};
	}

	return {
		redirectPath: null,
	};
}
